import { Api } from 'models/services/api';
import { ReadRelationshipsByParentIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  parentId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByParentId($parentId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByParentIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByParentId: RelationshipCollectionData;
  }
}

class ReadCollectionByParentIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByParentId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByParentIdGql };
